import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import InventoryView from '@/views/InventoryView.vue';
import PageNotFoundView from '@/views/PageNotFoundView.vue';
import { confirmAccess, useUserStore } from '@/services/auth';
import { getAuth } from 'firebase/auth';
import WebQuotesView from '@/views/WebQuotesView.vue';
import UsersView from '@/views/UsersView.vue';
import WebOrdersView from '@/views/WebOrdersView.vue';

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'home',
		component: HomeView
	},
	{
		path: '/inventory',
		name: 'inventory',
		component: InventoryView,
		meta: { requiresAdmin: 'true' }
	},
	{
		path: '/webquotes',
		name: 'webquotes',
		component: WebQuotesView
	},
	{
		path: '/weborders',
		name: 'weborders',
		component: WebOrdersView
	},
	{
		path: '/users',
		name: 'users',
		component: UsersView,
		meta: { requiresServerAdmin: 'true' }
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'pageNotFound',
		component: PageNotFoundView
	}
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
});

router.beforeEach(async (to, _) => {
	if (to.meta.requiresAdmin) {
		const auth = getAuth(); // get auth
		await auth.authStateReady(); // ensure user is found
		await confirmAccess(auth); // enure user is an admin
		const userStore = useUserStore(); // access user store
		const { admin } = userStore; // get admin claims

		if (!admin) {
			return { name: 'pageNotFound' };
		}
	}

	if (to.meta.requiresServerAdmin) {
		const auth = getAuth(); // get auth
		await auth.authStateReady(); // ensure user is found
		await confirmAccess(auth); // enure user is an admin
		const userStore = useUserStore(); // access user store
		const { serverAdmin } = userStore; // get server admin claims

		if (!serverAdmin) {
			return { name: 'pageNotFound' };
		}
	}
});

export default router;
